import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Offcanvas } from "react-bootstrap";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Loading_Lottie from "../../../animation/loading_lottie/Loading_Lottie";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import "./Common_Report_Offcanvas.css";

const Common_Report_Offcanvas = ({
  show,
  handleClose,
  setSuccess,
  title,
  setShowLottie,
  showLottie,
  reportPath,
}) => {
  useEffect(() => {
    setTimeout(() => {
      setShowLottie(false);
    }, 3000);
  }, []);

  const onSubmit = async (data) => {
    handleClose();
    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
      handleClose();
    }, 3000);
  };
  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title}.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  // const handleShareReport = async (filePath) => {
  //   if (!filePath) {
  //     alert("Report not available");
  //     return;
  //   }

  //   try {
  //     // fetch file
  //     const response = await fetch(filePath);
  //     const blob = await response.blob();

  //     // create file object
  //     const file = new File([blob], "SampleReport.pdf", {
  //       type: blob.type,
  //     });

  //     // share file
  //     if (navigator.canShare && navigator.canShare({ files: [file] })) {
  //       await navigator.share({
  //         title: "Sample Report",
  //         text: "Here is your report",
  //         files: [file],
  //       });
  //     } else {
  //       alert("File sharing not supported on this browser");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Sharing failed");
  //   }
  // };

  const handleShareReport = async (filePath) => {
    if (!filePath) {
      alert("Report not available");
      return;
    }

    try {
      if (navigator.share) {
        await navigator.share({
          title: "Sample Report",
          text: "Here is your report",
          url: filePath,
        });
      } else {
        await navigator.clipboard.writeText(filePath);
        alert("Report link copied to clipboard");
      }
    } catch (error) {
      console.error("Share failed:", error);
    }
  };
  return (
    <Offcanvas
      className="mobile_offcanvas Common_Report_Offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="main_content_div">
          {showLottie ? (
            <div className="lottie_div">
              <Loading_Lottie />
            </div>
          ) : (
            <div className="report_div">
              <div className="exl_img_holder">
                <img src="/assets/images/other/xlsx.png" className="xl_img" />
              </div>

              <div className="report_footer">
                <p className="inner_text">
                  Your Report Has Been Successfully Generated. You Can Now
                  Download Or Share It.
                </p>

                <Black_Submit_Btn
                  btnText={"Download Report"}
                  onClick={() => handleDownloadInvoice(reportPath)}
                />
                <Gray_Btn
                  btnText={"Share Report"}
                  onClick={() =>
                    handleShareReport(
                      `${process.env.REACT_APP_IMG_URL}${reportPath}`,
                    )
                  }
                />
              </div>
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Common_Report_Offcanvas;
